// THIS IS A GENERATED FILE
import * as Types from '@gatsbyjs/graphql/types';

import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/react-hooks';


export type SitePlatformLimitSummariesQueryVariables = Types.Exact<{
  workspaceId: Types.Scalars['UUID'];
  siteId: Types.Scalars['UUID'];
}>;


export type SitePlatformLimitSummariesQuery = (
  { __typename?: 'Query' }
  & { platformLimitSummaries?: Types.Maybe<Array<Types.Maybe<(
    { __typename?: 'PlatformLimitSummary' }
    & Pick<Types.PlatformLimitSummary, 'name' | 'id' | 'overage' | 'limit' | 'formattedLimit' | 'overageCount' | 'formattedOverageCount'>
    & { workspace: (
      { __typename?: 'PlatformUsage' }
      & Pick<Types.PlatformUsage, 'count' | 'formattedCount' | 'percentageOfLimit'>
    ), site?: Types.Maybe<(
      { __typename?: 'PlatformUsage' }
      & Pick<Types.PlatformUsage, 'count' | 'formattedCount' | 'percentageOfLimit'>
    )> }
  )>>> }
);

export type IsSiteBeingTransferredQueryVariables = Types.Exact<{
  id: Types.Scalars['UUID'];
}>;


export type IsSiteBeingTransferredQuery = (
  { __typename?: 'Query' }
  & Pick<Types.Query, 'isSiteBeingTransferred'>
);

export type GetSiteTransferInvitationQueryVariables = Types.Exact<{
  id: Types.Scalars['UUID'];
}>;


export type GetSiteTransferInvitationQuery = (
  { __typename?: 'Query' }
  & { getSiteTransferInvitation?: Types.Maybe<(
    { __typename?: 'Invitation' }
    & Pick<Types.Invitation, 'id' | 'type' | 'invitationUserId' | 'invitationName' | 'invitationEmail' | 'senderUserId' | 'accepted' | 'expired'>
    & { resources?: Types.Maybe<Array<Types.Maybe<(
      { __typename?: 'InvitationResource' }
      & Pick<Types.InvitationResource, 'resourceType' | 'resourceId' | 'role'>
    )>>> }
  )> }
);

export type SiteTransferDetailsQueryVariables = Types.Exact<{
  id: Types.Scalars['UUID'];
}>;


export type SiteTransferDetailsQuery = (
  { __typename?: 'Query' }
  & { siteTransferDetails?: Types.Maybe<(
    { __typename?: 'SiteTransferDetails' }
    & Pick<Types.SiteTransferDetails, 'siteId' | 'siteName' | 'sitePublicName' | 'orgId' | 'orgName'>
  )> }
);


export const SitePlatformLimitSummariesDocument = gql`
    query SitePlatformLimitSummaries($workspaceId: UUID!, $siteId: UUID!) {
  platformLimitSummaries(workspaceId: $workspaceId) {
    name
    id
    overage
    limit
    formattedLimit
    overageCount
    formattedOverageCount
    workspace {
      count
      formattedCount
      percentageOfLimit
    }
    site(id: $siteId) {
      count
      formattedCount
      percentageOfLimit
    }
  }
}
    `;

/**
 * __useSitePlatformLimitSummariesQuery__
 *
 * To run a query within a React component, call `useSitePlatformLimitSummariesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSitePlatformLimitSummariesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSitePlatformLimitSummariesQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useSitePlatformLimitSummariesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SitePlatformLimitSummariesQuery, SitePlatformLimitSummariesQueryVariables>) {
        return ApolloReactHooks.useQuery<SitePlatformLimitSummariesQuery, SitePlatformLimitSummariesQueryVariables>(SitePlatformLimitSummariesDocument, baseOptions);
      }
export function useSitePlatformLimitSummariesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SitePlatformLimitSummariesQuery, SitePlatformLimitSummariesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<SitePlatformLimitSummariesQuery, SitePlatformLimitSummariesQueryVariables>(SitePlatformLimitSummariesDocument, baseOptions);
        }
export type SitePlatformLimitSummariesQueryHookResult = ReturnType<typeof useSitePlatformLimitSummariesQuery>;
export type SitePlatformLimitSummariesLazyQueryHookResult = ReturnType<typeof useSitePlatformLimitSummariesLazyQuery>;
export type SitePlatformLimitSummariesQueryResult = ApolloReactCommon.QueryResult<SitePlatformLimitSummariesQuery, SitePlatformLimitSummariesQueryVariables>;
export const IsSiteBeingTransferredDocument = gql`
    query IsSiteBeingTransferred($id: UUID!) {
  isSiteBeingTransferred(id: $id)
}
    `;

/**
 * __useIsSiteBeingTransferredQuery__
 *
 * To run a query within a React component, call `useIsSiteBeingTransferredQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsSiteBeingTransferredQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsSiteBeingTransferredQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useIsSiteBeingTransferredQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IsSiteBeingTransferredQuery, IsSiteBeingTransferredQueryVariables>) {
        return ApolloReactHooks.useQuery<IsSiteBeingTransferredQuery, IsSiteBeingTransferredQueryVariables>(IsSiteBeingTransferredDocument, baseOptions);
      }
export function useIsSiteBeingTransferredLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IsSiteBeingTransferredQuery, IsSiteBeingTransferredQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IsSiteBeingTransferredQuery, IsSiteBeingTransferredQueryVariables>(IsSiteBeingTransferredDocument, baseOptions);
        }
export type IsSiteBeingTransferredQueryHookResult = ReturnType<typeof useIsSiteBeingTransferredQuery>;
export type IsSiteBeingTransferredLazyQueryHookResult = ReturnType<typeof useIsSiteBeingTransferredLazyQuery>;
export type IsSiteBeingTransferredQueryResult = ApolloReactCommon.QueryResult<IsSiteBeingTransferredQuery, IsSiteBeingTransferredQueryVariables>;
export const GetSiteTransferInvitationDocument = gql`
    query GetSiteTransferInvitation($id: UUID!) {
  getSiteTransferInvitation(id: $id) {
    id
    type
    invitationUserId
    invitationName
    invitationEmail
    senderUserId
    accepted
    expired
    resources {
      resourceType
      resourceId
      role
    }
  }
}
    `;

/**
 * __useGetSiteTransferInvitationQuery__
 *
 * To run a query within a React component, call `useGetSiteTransferInvitationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSiteTransferInvitationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSiteTransferInvitationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSiteTransferInvitationQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetSiteTransferInvitationQuery, GetSiteTransferInvitationQueryVariables>) {
        return ApolloReactHooks.useQuery<GetSiteTransferInvitationQuery, GetSiteTransferInvitationQueryVariables>(GetSiteTransferInvitationDocument, baseOptions);
      }
export function useGetSiteTransferInvitationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetSiteTransferInvitationQuery, GetSiteTransferInvitationQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetSiteTransferInvitationQuery, GetSiteTransferInvitationQueryVariables>(GetSiteTransferInvitationDocument, baseOptions);
        }
export type GetSiteTransferInvitationQueryHookResult = ReturnType<typeof useGetSiteTransferInvitationQuery>;
export type GetSiteTransferInvitationLazyQueryHookResult = ReturnType<typeof useGetSiteTransferInvitationLazyQuery>;
export type GetSiteTransferInvitationQueryResult = ApolloReactCommon.QueryResult<GetSiteTransferInvitationQuery, GetSiteTransferInvitationQueryVariables>;
export const SiteTransferDetailsDocument = gql`
    query SiteTransferDetails($id: UUID!) {
  siteTransferDetails(siteId: $id) {
    siteId
    siteName
    sitePublicName
    orgId
    orgName
  }
}
    `;

/**
 * __useSiteTransferDetailsQuery__
 *
 * To run a query within a React component, call `useSiteTransferDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSiteTransferDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSiteTransferDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSiteTransferDetailsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SiteTransferDetailsQuery, SiteTransferDetailsQueryVariables>) {
        return ApolloReactHooks.useQuery<SiteTransferDetailsQuery, SiteTransferDetailsQueryVariables>(SiteTransferDetailsDocument, baseOptions);
      }
export function useSiteTransferDetailsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SiteTransferDetailsQuery, SiteTransferDetailsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<SiteTransferDetailsQuery, SiteTransferDetailsQueryVariables>(SiteTransferDetailsDocument, baseOptions);
        }
export type SiteTransferDetailsQueryHookResult = ReturnType<typeof useSiteTransferDetailsQuery>;
export type SiteTransferDetailsLazyQueryHookResult = ReturnType<typeof useSiteTransferDetailsLazyQuery>;
export type SiteTransferDetailsQueryResult = ApolloReactCommon.QueryResult<SiteTransferDetailsQuery, SiteTransferDetailsQueryVariables>;
